export const urlAppendSearchParams = (url: string, params?: object) => {
  if (params && Object.keys(params).length > 0) {
    url += '?';
    Object.entries(params).map(([key, value], index) => {
      url += `${key}=${value}`;
      if (index < Object.keys(params).length - 1) {
        url += `&`;
      }
    });
  }
  return url;
};
